import * as z from "zod";
import {
  dateSchema,
  requiredString,
} from "components/form/utils";

const participantSchema = z.object({
  id: z.string().uuid().optional(), // For existing participants
  email: z.string().email("Invalid email address").nonempty("Email cannot be empty"),
  _isNew: z.boolean().optional(), // Track if it's a new participant
});

export const meetingSchema = z.object({
  title: requiredString().nonempty("Title cannot be empty"),
  starts_at: dateSchema.optional().nullable(),
  ends_at: dateSchema.optional().nullable(),
  participants: z.array(participantSchema).optional().default([]),
});
